import React from 'react';
import PropTypes from 'prop-types';
import CalendarClockIcon from 'mdi-react/CalendarClockIcon';
import trackEvent from '../../../shared/functions/trackEvent';

// The founder's scheduling link as a pill centred at the top of the startup
// page, in the spot the results capsule takes on the founder's own pages, so
// an investor can pick a time without scrolling. Nothing renders when the
// founder has not set a link in Settings > Booking Link.
const TopbarBookCall = ({ bookingLink }) => {
  if (!bookingLink) return null;

  return (
    <a
      className="topbar__book-call"
      href={bookingLink}
      target="_blank"
      rel="noopener noreferrer"
      title="Book a call with the founder"
      onClick={() => trackEvent('book_call_clicked')}
    >
      <span className="topbar__book-call-icon"><CalendarClockIcon /></span>
      <span className="topbar__book-call-label">Book a call</span>
    </a>
  );
};

TopbarBookCall.propTypes = {
  bookingLink: PropTypes.string,
};

TopbarBookCall.defaultProps = {
  bookingLink: null,
};

export default TopbarBookCall;
